import React, { useState } from 'react';

import { IAuditionScheduleAttributes } from 'shared/interfaces/IAuditionSchedule';
import Files from './Files/Files';
import QAndA from './QAndA/QAndA';
import { SelectionContainer, Heading, MainContainer, SelectionButton } from './Summary.styles';

interface Props {
  data?: IAuditionScheduleAttributes;
}

const Summary: React.FC<Props> = ({ data }) => {
  const [activeTab, setActiveTab] = useState<'Files' | 'QandA'>('Files');
  return (
    <MainContainer>
      <Heading fontSize={18}>Self Tape Summary</Heading>
      <SelectionContainer>
        <SelectionButton isActive={activeTab === 'Files'} onClick={() => setActiveTab('Files')}>
          Self Tape Files
        </SelectionButton>
        <SelectionButton isActive={activeTab === 'QandA'} onClick={() => setActiveTab('QandA')}>
          Questions & Answers
        </SelectionButton>
      </SelectionContainer>
      {activeTab === 'Files' ? <Files data={data?.medium_attachments} /> : <QAndA data={data?.answers} />}
    </MainContainer>
  );
};

export default Summary;
